// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarToggleTrashButton.tsx
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ViewListIcon from "@mui/icons-material/ViewList";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";

interface DataGridToolbarToggleTrashButtonProps extends DataGridToolbarProps {}

export default function DataGridToolbarToggleTrashButton({
  trashType,
  setTrashType,
  buttonSize,
}: DataGridToolbarToggleTrashButtonProps) {
  return (
    <DataGridToolbarButtonContainer>
      {!trashType && (
        <Tooltip title={I18n.t("App.showTrash")}>
          <IconButton
            onClick={() => setTrashType && setTrashType("onlyTrashed")}
            size={buttonSize}
          >
            <DeleteOutlineIcon fontSize={buttonSize} />
          </IconButton>
        </Tooltip>
      )}
      {trashType === "onlyTrashed" && (
        <Tooltip title={I18n.t("App.showList")}>
          <IconButton
            onClick={() => setTrashType && setTrashType(undefined)}
            size={buttonSize}
          >
            <ViewListIcon fontSize={buttonSize} />
          </IconButton>
        </Tooltip>
      )}
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarToggleTrashButton.tsx